import { useQuery } from "@tanstack/react-query";

import { listTeamTimeEntries } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { TimeEntry, WeekRange } from "../types";
import { toTimeEntry } from "../utils/map";

export function useTeamTimeEntries(range: WeekRange, enabled = true) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["time-entries", "team", activeCanteiroId, range.from, range.to],
		enabled: enabled && activeCanteiroId != null,
		queryFn: async (): Promise<TimeEntry[]> => {
			const { items } = await listTeamTimeEntries(activeCanteiroId as string, {
				from: range.from,
				to: range.to,
			});
			return items.map(toTimeEntry);
		},
		staleTime: 30_000,
	});
}
